(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawarmor-how"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pawarmor-how')){
customElements.define('pawarmor-how',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.track=this.querySelector('.sa-how__track');this.cards=Array.from(this.querySelectorAll('.sa-how__card'));this.dots=Array.from(this.querySelectorAll('[data-slide]'));
this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;this.visibleCards=new Set();
this.go=(n)=>{this.index=Math.max(0,Math.min(this.cards.length-1,n));this.track.scrollTo({left:this.cards[this.index].offsetLeft-this.cards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});this.paint();};
this.querySelector('[data-prev]').onclick=()=>this.go(this.index-1);
this.querySelector('[data-next]').onclick=()=>this.go(this.index+1);
this.dots.forEach((b,i)=>b.onclick=()=>this.go(i));
this.track.addEventListener('scroll',()=>{if(this.track.scrollWidth<=this.track.clientWidth)return;clearTimeout(this.timer);this.timer=setTimeout(()=>{this.index=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2?this.cards.length-1:Math.min(this.cards.length-1,Math.round(this.track.scrollLeft/194));this.paint();},100);},{passive:true});
this.observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting)this.visibleCards.add(entry.target);else this.visibleCards.delete(entry.target);});this.paint();},{threshold:0});this.cards.forEach(card=>this.observer.observe(card));
this.paint();
}
paint(){
this.cards.forEach((c,i)=>{const img=c.querySelector('img');if(img){const src=this.visibleCards.has(c)&&!this.paused?img.dataset.motion:img.dataset.still;if(img.getAttribute('src')!==src)img.src=src;}});
this.dots.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===this.index)));
this.querySelector('[data-prev]').disabled=this.index===0;this.querySelector('[data-next]').disabled=this.index===this.cards.length-1;
}
disconnectedCallback(){this.observer?.disconnect();clearTimeout(this.timer);this.ready=false;}
});
}

  } catch(e) { console.error(e); }
})();
})();
